import { Talent } from '../../Classes'

export default [null, null, new Talent('Lightning Reflexes', 'spell_nature_invisibilty', ['Increases your agility by ', '%.'], 5, [[3, 6, 9, 12, 15]]), null]
